var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCircleHalfTilt = function SvgIconCircleHalfTilt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m4.928 19.073-.046-.05A9.97 9.97 0 0 1 2 12C2 6.477 6.477 2 12 2a9.97 9.97 0 0 1 7.016 2.874 1 1 0 0 1 .11.11A9.97 9.97 0 0 1 22 12c0 5.523-4.477 10-10 10a9.97 9.97 0 0 1-7.072-2.927M12 4a8 8 0 0 0-6.32 12.906l3.724-3.723.028-.03 3.722-3.72.028-.03 3.722-3.72.002-.003A7.97 7.97 0 0 0 12 4M9.125 16.29l-2.03 2.03a8 8 0 0 0 2.03 1.148zm2 3.663V14.29l1.75-1.75v7.413a8 8 0 0 1-1.75 0m5.5-1.425a8 8 0 0 1-1.75.94V10.54l1.75-1.75zm2-11.014A7.96 7.96 0 0 1 20 12a7.96 7.96 0 0 1-1.375 4.486z",
    clipRule: "evenodd"
  })));
};
export default SvgIconCircleHalfTilt;